(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-marquee-countdown"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const countdowns = document.querySelectorAll('.image-marquee-countdown .countdown[data-target]');
    if (!countdowns.length) return;

   for (const countdown of countdowns) {
      const targetDateStr = countdown.getAttribute('data-target');
      if (!targetDateStr) continue;

      const targetDate = new Date(targetDateStr);
      if (isNaN(targetDate.getTime())) {
        countdown.innerHTML = '<div class="countdown-ended">Invalid date format</div>';
        continue;
      }

      const daysEl = countdown.querySelector('[data-unit="days"]');
      const hoursEl = countdown.querySelector('[data-unit="hours"]');
      const minutesEl = countdown.querySelector('[data-unit="minutes"]');
      const secondsEl = countdown.querySelector('[data-unit="seconds"]');

      function updateCountdown() {
        const now = new Date();
        const difference = targetDate - now;

        if (difference <= 0) {
          countdown.innerHTML = '<div class="countdown-ended">Offer ended</div>';
          return;
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
        if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
        if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
        if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }
  });
  
  } catch(e) { console.error(e); }
})();
})();
